import * as actionTypes from './sidebarMenuCountActionTypes';

export const setSidebarMenuCountTrue = () => ({
    type: actionTypes.TRUE_CALL_SIDEBAR_MENU_COUNT
});

export const setSidebarMenuCountFalse = () => ({
    type: actionTypes.FALSE_CALL_SIDEBAR_MENU_COUNT
});